.dj{padding:0.5rem;}